import styled from 'styled-components';

import * as Base from './locked-offers-card.styled.default';

const TH_CARD_WIDTH = '400px';
const TH_MOBILE_CARD_WIDTH = '300px';

export const Container = styled(Base.Container)`
  width: ${TH_MOBILE_CARD_WIDTH};
  min-width: ${TH_MOBILE_CARD_WIDTH};
  ${Styles.desktop`
    width: ${TH_CARD_WIDTH}
    min-width: ${TH_CARD_WIDTH}
  `};
`;

export * from './locked-offers-card.styled.default';
